/**
 * Which city landing page, if any, a listing belongs to.
 *
 * Used by pages/buyer/VehicleDetail.js and scripts/inject-seo-heads.js so the
 * link and breadcrumb a crawler reads match the ones a visitor gets. Takes
 * CITY_SEO as an argument rather than importing it — the injector loads this
 * file by stripping `export` and requiring it, so it must stay import-free.
 *
 * Matching mirrors the backend's LOWER(city) LIKE '%name%' tier-0 test that
 * the city pages themselves count stock with, so "South West Delhi" and
 * "New Delhi" both belong to /buy-taxi-delhi. Only INDEXABLE city pages are
 * returned: linking 78 listings at a noindexed page would spend internal
 * equity on a page that has asked not to rank.
 */
export function cityPageFor(vehicleCity, citySeo) {
  const city = String(vehicleCity || '').toLowerCase();
  if (!city || !citySeo) return null;
  for (const slug of Object.keys(citySeo)) {
    if (citySeo[slug] && citySeo[slug].noindex) continue;
    if (city.includes(slug)) {
      const name = slug.charAt(0).toUpperCase() + slug.slice(1);
      return { slug, name, path: `/buy-taxi-${slug}` };
    }
  }
  return null;
}
